export default "__VITE_ASSET__C3qDEjT1__"